import UniqFinalPackingListRoutes from "./uniq_final_packing_list";
import FinalPackingListSimplifiedRoutes from "./final_packing_list_simplified";
import PalletizedRoutes from "./palletized";
import PackingByPalletRoutes from "./packing_by_pallet";

export default [
  ...UniqFinalPackingListRoutes,
  ...FinalPackingListSimplifiedRoutes,
  ...PalletizedRoutes,
  ...PackingByPalletRoutes,
];
